export const CAMPAIGN_TYPE_URL_SECTION = ':type';

export const CAMPAIGN_ID_URL_SECTION = ':id';

export const ROUTE_PATH = `/campaigns/${CAMPAIGN_TYPE_URL_SECTION}/${CAMPAIGN_ID_URL_SECTION}`;
